














import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoBlock from '@/shared/components/respondeco-block.vue'
import { Prop } from 'vue-property-decorator'
import { ProjectPartner } from '@/api/generated'
import { isNotBlank } from '@/shared/utils/is-blank'

@Component({
  components: { RespondecoBlock },
})
export default class ProjectLearning extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly partner!: ProjectPartner

  public get hasTestimonial(): boolean {
    return isNotBlank(this.partner.testimonial)
  }
}
